import logo from "assets/images/brands/Seamless-Logo.png";
import smLogo from "assets/images/brands/Seamless-Logo.png";

export const clientName = "Seamless Markets";
export const developedBy = "Seamless Markets";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const companyName =  "Seamless Markets";
export const sidebarLogo = smLogo;
export const mainLogo = logo;
export const lightLogo = logo;
